import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class LoadingState extends BaseState {

  begin() {
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)

    Signals.gameMessage.dispatch({message: 'openSocket'})
    Signals.socketOpened.add(_ => {
      Signals.gameMessage.dispatch({message: 'preauth'})
      Signals.preAuth.add(_ => Signals.loadAssets.dispatch())
    })
  }

  onContinueBtnClick() {
    this.end()
  }

  end = () => {
    // TODO: We've skip the open socket state. It's redundant now
    this.stateMachine.setState(GameStatesEnum.INIT)
  }

  cleanUp() {
    Signals.continueBtnClick.remove(this.onContinueBtnClick, this)
  }

}
